import { useIsDineInScan } from '@/hooks/useIsDineInScan'
import { useAppSelector } from '@/store'
import { selectIsDineIn } from '@/store/ticketSlice'

// Redux has no DINE_IN until StartOrder runs after the menu mounts, so the ?dineIn param covers first load.
// Use this for any request that fires on first render.
export function useIsDineInSession(): boolean {
	const isDineInOrderType = useAppSelector(selectIsDineIn)
	const isDineInScan = useIsDineInScan()

	return isDineInOrderType || isDineInScan
}
